import { render, staticRenderFns } from "./batch_transfer.vue?vue&type=template&id=79caa542&scoped=true&"
import script from "./batch_transfer.vue?vue&type=script&lang=js&"
export * from "./batch_transfer.vue?vue&type=script&lang=js&"
import style0 from "./batch_transfer.vue?vue&type=style&index=0&id=79caa542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79caa542",
  null
  
)

export default component.exports